/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import SalesIcon from "../../../../../assets/images/icon_menus/SalesIcon.json";
import clsx from "clsx";
import { Col, Row, Modal, Space } from "antd";
import { Button, TableRow, TableCell, Typography, TextField } from "@mui/material";
import transActions from "../../../Transactions/redux/actions";
import { CustomAccordion } from "../../../../Shared/components/AccordionComponent";
import { useDispatch, useSelector } from "react-redux";
import usePrevious from "../../../../Shared/components/Previous";
import crudActions from "../../../../CRUD/redux/actions";
import { useParams, Link } from "react-router-dom";
import moment from 'moment';
import { emptyValidation } from "../../../../../helpers/validation";
import { toast } from 'react-toastify';
import { capitalizeFirstLetter, currencyFormat, checkCRUDViewPermission, idNamingConversion, checkCRUDPermission, checkComponentPermission } from "../../../../../helpers/utilities";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { selectInvoiceViewHead, confirmedselectInvoiceViewHead } from "../../../../../config/constant";
import { AESEncrypt, AESDecrypt } from "../../../../../helpers/Crypto";
import { useEventListener } from "../../../../../helpers/useEventListener";
import { CustomModal } from "../../../../Shared/components/DeleteModal";


const CustomerPaymentView = (props) => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [reason, setReason] = useState('');
    const { deleteDetails, readDetails, createDetails, createError, createLoader, editDetails, editError, editLoader } = useSelector(state => state.crudReducer);

    const [errorReason, setErrorReason] = useState(false);
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const dispatch = useDispatch();
    const { history } = props;
    let { paymentId, customiseId } = useParams();
    const decryptedId = AESDecrypt(paymentId);
    const prevReadDetails = usePrevious(readDetails);
    const prevDeleteDetails = usePrevious(deleteDetails);
    const [showDetails, setShowDetails] = useState(true);
    const [confirm, setConfirm] = useState(false);
    const { roleManagement } = useSelector(state => state.authReducer);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);

    const onDelete = () => {
        setIsModalVisible(true);
    }

    useEffect(() => {
        if (prevReadDetails !== undefined && readDetails && prevReadDetails !== readDetails) {
            setShowDetails(false);
        }
    }, [readDetails]);

    const handleKeyDown = (e) => {
        if (e.altKey && e.keyCode === 69) {
            e.preventDefault();
            history.push(`/sales/sales-management/customer-payment/${AESEncrypt(decryptedId)}/edit`);
        } else if (e.altKey && e.keyCode === 79) {
            e.preventDefault();
            setConfirm(true);
        }
        // else if (e.altKey && e.keyCode === 83) {
        //     e.preventDefault();
        //     if(confirm){
        //         handleStatus('CONFIRMED')
        //     }
        // }
    }
    useEventListener("keydown", handleKeyDown);

    const handleCancel = () => {
        setIsModalVisible(false);
        setErrorReason(false);
        setReason('');
    };

    useEffect(() => {
        if (paymentId === undefined || decryptedId === 0) {
            history.push("/sales/sales-management/customer-payment");
            return true;
        }

        if (roleManagement !== '' && checkCRUDViewPermission('Customer Payment', 'view', history, 'Sales')) {
            dispatch({ type: crudActions.READ_DETAILS_START, id: decryptedId, url: "customerPayment" });
        }

        return () => {
            dispatch({ type: transActions.CLEAR_SALES_TRANSACTION_DETAILS_START });
        }
    }, [paymentId, roleManagement]);


    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            toast.dismiss();
            //toast(editDetails);
            setConfirm(false);
            history.push("/sales/sales-management/customer-payment");
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let message = createError.error.message;
            toast.dismiss();
            toast.error(message);
        }
    }, [createDetails, createError]);


    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            toast.dismiss();
            setErrorReason('');
            handleCancel();
            history.push("/sales/sales-management/customer-payment");
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let message = editError.error.message;
            toast.dismiss();
            toast.error(message);
        }
    }, [editDetails, editError]);


    const handleStatus = (status) => {
        dispatch({
            type: crudActions.CREATE_DETAILS_START,
            url: `/customerPayment/${decryptedId}/confirmPayment`,
            title: 'Customer Payment'
        });
    }

    const deletePayment = (e) => {
        e.preventDefault();
        let emptyReason = emptyValidation('Reason', reason);
        if (emptyReason.isValid) {
            dispatch({
                type: crudActions.EDIT_DETAILS_START,
                url: 'customerPayment',
                title: 'Customer Payment',
                id: decryptedId,
                slug: "cancel",
                details: {
                    reversalReason: reason
                }
            });
        } else {
            if (emptyReason.errors) {
                setErrorReason(emptyReason.errors);
            }
        }
    }

    useEffect(() => {
        if (prevDeleteDetails !== undefined && deleteDetails && prevDeleteDetails !== deleteDetails) {
            setIsModalVisible(false);
            toast.dismiss();
            toast(deleteDetails);
            history.push("/sales/sales-management/customer-payment");
        }
    }, [deleteDetails]);


    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader
                {...props}
                cls={'newImg'}
                img={SalesIcon}
                title={'Sales'}
                closeLink={customiseId ? '' : '/sales/sales-management/customer-payment'}
                links={[{ 'label': 'Sales', 'link': '/sales' }, { 'label': 'Customer Payments', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.listTableSticky, { [classes.scrollBorder]: !showDetails })}>
                <div id="containerDiv" className={clsx(classes.stickyContainer)}>
                    <CustomAccordion
                        title={'View Payment'}
                        top={"0"}
                        topVisible={"50px"}
                        zIndex={9}
                        showDetails={showDetails}
                        index={0}
                        component={
                            <>
                                {
                                    showDetails === false && readDetails && (
                                        <Row gutter={50} className={classes.ButtonRelative}>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={24} xs={24}>
                                                <Typography className={clsx(classes.aTitle)}>{`${readDetails.serialNo}`}</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={14} >
                                                <span className={clsx(classes.statusButton, classes.collectPayment, classes.disInline, { [classes.confirmedButton]: readDetails.paymentStatus === 'CONFIRMED' }, { [classes.reversedButton]: readDetails.paymentStatus === 'CANCELLED' })}>{capitalizeFirstLetter(readDetails.paymentStatus)}</span>
                                            </Col>
                                            <Col xxl={14} xl={14} lg={12} md={8} sm={12} xs={10} className={clsx(classes.textAlignRight, classes.ButtonStatic, classes.displayFlexPayment, classes.collectPayment)}>
                                                <Space direction="horizontal" align="center" size={[10, 10]} className={clsx(classes.ButtonAbsolute, classes.OverallPaymentButton)}>
                                                    {
                                                        (readDetails.paymentStatus === 'CREATED') &&
                                                        <>
                                                            {
                                                                roleManagement !== '' && checkCRUDPermission('Customer Payment', 'edit', 'Sales') &&
                                                                <Link to={`/sales/sales-management/customer-payment/${AESEncrypt(decryptedId)}/edit`} className={clsx(classes.AddMoreBtn, classes.bold, classes.marginRight0)}>Edit</Link>
                                                            }
                                                            {
                                                                roleManagement !== '' && checkComponentPermission('Customer Payment', 'Action', 'Confirm') &&
                                                                <> <Button
                                                                    key="Cancel"
                                                                    color="primary"
                                                                    variant="contained"
                                                                    id={idNamingConversion('Confirm', 'customerPayment', 'DropDown')}
                                                                    onClick={() => setConfirm(true)}
                                                                    className={clsx(classes.modalBtn, classes.marginRight0, { [classes.loading]: createLoader })}
                                                                >Confirm</Button>
                                                                </>
                                                            }
                                                        </>
                                                    }
                                                    {
                                                        (readDetails.paymentStatus === 'CONFIRMED') && !readDetails?.customerPaymentItems &&
                                                        <>
                                                            {
                                                                roleManagement !== '' && checkComponentPermission('Customer Payment', 'Action', 'View Cancel') &&
                                                                <Button
                                                                    key="Cancel"
                                                                    color="primary"
                                                                    variant="contained"
                                                                    className={clsx(classes.deleteBtn, classes.marginRight0)}
                                                                    onClick={() => onDelete(readDetails)}
                                                                >Cancel</Button>
                                                            }
                                                        </>
                                                    }
                                                </Space>
                                            </Col>

                                            <Col xxl={10} xl={10} lg={6} md={8} sm={12} xs={24}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Customer Name</Typography>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.customer ? readDetails.customer.name : '---'}</Typography>
                                            </Col>

                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Payment Date</Typography>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{moment(readDetails.date).format('DD MMM YYYY')}</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Method Of Payment</Typography>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.mop ? readDetails.mop.method : '---'}</Typography>
                                            </Col>
                                            <Col xxl={4} xl={4} lg={6} md={8} sm={12} xs={24}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Sales Rep</Typography>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.salesRep?.name || '---'}</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Currency</Typography>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.currency ? readDetails.currency.name : '---'}</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Customer ID</Typography>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails?.customer?.serialNo ? readDetails?.customer?.serialNo : '---'}</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Payment Amount</Typography>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(readDetails.paymentAmount)}</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Payment Reference (Optional)</Typography>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.reference ? readDetails.reference : '---'}</Typography>
                                            </Col>
                                            <Col xxl={4} xl={4} lg={6} md={8} sm={12} xs={24}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Description (Optional)</Typography>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldColor, classes.fonSize14, classes.descEllipsis)}>{readDetails.description ? readDetails.description : '---'}</Typography>
                                            </Col>
                                        </Row>
                                    )
                                }
                                {
                                    showDetails === true && (
                                        <div style={{ textAlign: "center" }}>
                                            <div className={classes.loadMoreCircle}></div>
                                        </div>
                                    )
                                }
                            </>
                        }
                    />
                    <CustomAccordion
                        title={'Selected Invoice'}
                        top={"49"}
                        topVisible={"150px"}
                        zIndex={7}
                        showDetails={showDetails}
                        index={1}
                        component={
                            <div className={clsx(classes.tableRoot, classes.tableRootSelectInvoiceView)} style={{ height: "100%" }}>
                                <CustomInfiniteScroll
                                    styles={'height:100%'}
                                    heads={readDetails.paymentStatus === 'CONFIRMED' ? selectInvoiceViewHead : confirmedselectInvoiceViewHead}
                                    width={true}
                                    loadMore={true}
                                    customClasses={classes.tableRoot}
                                    loadMoreContent={false}
                                    component={
                                        <>
                                            {
                                                showDetails === false ? readDetails?.customerPaymentItems
                                                    && readDetails?.customerPaymentItems?.length > 0 ?
                                                    readDetails?.customerPaymentItems?.map((data, i) => (
                                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={i}  >
                                                            <TableCell>{data?.salesInvoice?.serialNo}</TableCell>
                                                            <TableCell>{moment(data?.salesInvoice?.invoiceDate).format('DD MMM YYYY')}</TableCell>
                                                            <TableCell className={classes.rightAlignAmount}>₹ {data?.salesInvoice?.invoiceAmount ? currencyFormat(data.salesInvoice.invoiceAmount) : '0.00'}</TableCell>
                                                            <TableCell>₹ {data?.amountToSettle ? currencyFormat(data?.amountToSettle) : '0.00'}</TableCell>
                                                        </TableRow>
                                                    )) : <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                        <TableCell className={classes.textAlignCenter} colSpan={8}> <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>
                                                            {readDetails.paymentStatus === 'CONFIRMED' ? 'No invoices has been settled against this payment' : 'No invoices has been selected to settle against this payment.'}

                                                        </p></TableCell>
                                                    </TableRow> : <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                    <TableCell className={classes.textAlignCenter} colSpan={8}><div className={classes.loadMoreCircle}></div></TableCell>
                                                </TableRow>
                                            }
                                        </>
                                    }
                                />
                            </div>
                        }
                        lastContent={true}
                    />
                </div>
            </div>
            <Modal
                title={'Reason for Cancellation'}
                open={isModalVisible}
                onOk={() => handleCancel()}
                onCancel={() => handleCancel()}
                className={clsx(classes.commonPopup, classes.deletePopup, classes.removeUnderline)}
                // closeIcon={<CloseIcon />}
                footer={[
                    roleManagement !== '' && checkComponentPermission('Customer Payment', 'Action', 'Confirm') &&
                    <Button
                        key="Confirm"
                        type='submit'
                        color='primary'
                        variant="contained"
                        className={clsx(classes.modalBtn, { [classes.loading]: editLoader })}
                        onClick={(e) => deletePayment(e)}
                    >Confirm</Button>,
                ]}
            >
                <TextField autoComplete='one-time-code'
                    label='Enter the reason for Cancellation'
                    fullWidth
                    variant={'standard'}
                    error={errorReason && true}
                    helperText={errorReason}
                    InputProps={{
                        classes: {
                            input: classes.textFieldColor,
                        }
                    }}
                    InputLabelProps={{
                        className: classes.textFieldLableColorCustom
                    }}
                    onChange={(e) => setReason(e.target.value)}
                />
            </Modal>
            <CustomModal
                visible={confirm}
                yesButton={'Yes'}
                noButton={'No'}
                loading={createLoader}
                title={'Payment Confirmation'}
                onOpen={() => handleStatus('CONFIRMED')}
                onClose={() => setConfirm(false)}
                text={<p>Are you sure do you want to Confirm the Payment?</p>}
            />
        </React.Fragment>
    )
}
export default CustomerPaymentView